/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css } from 'aphrodite';

import { ActionButton, colors } from '@blend/consumer-components';
import { styles as taskStyles } from '../../../components/form/styles';
import { ConsumerAppConfigContext, useConsumerTheme } from '../../../hooks/useConsumerTheme';

export namespace ExitWindowButton {
  export interface Props {}
}

const generateStyles = (_appConfig: ConsumerAppConfigContext) => ({
  ...taskStyles,
});

export const ExitWindowButton: React.FC<ExitWindowButton.Props> = ({}) => {
  const { styles } = useConsumerTheme(generateStyles);

  return (
    <div className={css(styles.ctaWrapper)}>
      <ActionButton
        data-dd-privacy="allow"
        color={colors.catalyst}
        customStyle={styles.button}
        onClick={() => window.close()}
        data-it="ExitWindowButton"
      >
        Exit window
      </ActionButton>
    </div>
  );
};
